// Brand & constants
export const BRAND = {
  name: 'UnfallHeld',
  tagline: 'Die digitale AI-Schadenplattform für Autofahrer.',
  short_tagline: 'Unfall digital melden. Schaden professionell abwickeln.',
  phone: '+436604145002',
  phoneDisplay: '+43 660 414 5002',
  whatsapp: '+436604145002',
  // Business hours - "Schaden ist jederzeit meldbar" wird separat kommuniziert.
  hours: {
    short: 'Mo–Fr 09:00–18:00 Uhr',
    long: 'Schaden jederzeit meldbar — wir melden uns schnellstmöglich zurück, oft auch außerhalb der Öffnungszeiten.',
  },
};

// Feature flags - flip to true once partners are onboarded.
// Backend mirrors these via GET /api/config.features.
export const FEATURES = {
  towing_enabled: false,
  pannenhilfe_enabled: false,
};

export const STATUS_LABELS = {
  neu: { label: 'Neu', cls: 'bg-blue-100 text-blue-900' },
  in_bearbeitung: { label: 'In Bearbeitung', cls: 'bg-amber-100 text-amber-900' },
  reparatur: { label: 'Reparatur', cls: 'bg-orange-100 text-orange-900' },
  fertig: { label: 'Fertig', cls: 'bg-green-100 text-green-900' },
};

export function statusBadge(status) {
  return STATUS_LABELS[status] || { label: status || '-', cls: 'bg-slate-100 text-slate-900' };
}

// New 8-step timeline (no towing references)
export const TIMELINE_STEPS = [
  { key: 'reported', label: 'Schaden gemeldet' },
  { key: 'data_received', label: 'Daten und Fotos erhalten' },
  { key: 'ai_assessment', label: 'KI-Ersteinschätzung erstellt' },
  { key: 'case_file_created', label: 'Schadenakte erstellt' },
  { key: 'documents_checked', label: 'Unterlagen geprüft' },
  { key: 'partner_coordination', label: 'Abstimmung mit Versicherung / Gutachter / Werkstatt' },
  { key: 'repair_in_progress', label: 'Reparatur / Bearbeitung in Abstimmung' },
  { key: 'case_closed', label: 'Fall abgeschlossen' },
];

// Backward-compat label mapping for cases created before the rename.
// We map old towing-related labels to neutral phrasing so customers/admins
// never see towing promises in existing cases.
export const LEGACY_TIMELINE_LABEL_MAP = {
  towing_arranged: 'Daten und Fotos erhalten',
  vehicle_picked_up: 'Schadenakte erstellt',
  expert_assigned: 'Abstimmung mit Gutachter',
  insurance_notified: 'Versicherung informiert',
  repair_done: 'Reparatur abgeschlossen',
  vehicle_delivered: 'Fall abgeschlossen',
};

export function timelineLabel(ev) {
  // Always prefer remap for legacy keys, otherwise use stored label.
  if (ev?.key && LEGACY_TIMELINE_LABEL_MAP[ev.key]) return LEGACY_TIMELINE_LABEL_MAP[ev.key];
  return ev?.label || ev?.key || '-';
}

// Pannenhilfe categories (kept for later reactivation)
export const BREAKDOWN_CATEGORIES = [
  { key: 'batterie', label: 'Batterie leer' },
  { key: 'reifen', label: 'Reifen beschädigt' },
  { key: 'motor', label: 'Motorproblem' },
  { key: 'startet_nicht', label: 'Fahrzeug startet nicht' },
  { key: 'sonstige', label: 'Sonstige Panne' },
];

export function formatDateTime(iso) {
  if (!iso) return '-';
  try {
    const d = new Date(iso);
    return d.toLocaleString('de-AT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch {
    return iso;
  }
}
